import React from 'react';
import { Link } from "react-router-dom";
import { AppstoreOutlined, SettingOutlined, DatabaseOutlined, LineChartOutlined, LaptopOutlined, ProfileOutlined, BlockOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Menu } from 'antd';

const TopMenu = ({selectKey}) => {

  const menualPopup = (e) => {
    e.preventDefault();
    e.stopPropagation();
      // 팝업 window의 크기 지정
    const width = 700; 
    const height = 850; 

    // 팝업을 부모 브라우저의 정 중앙에 나열
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;
    const windowOptions= `width=${width},height=${height},left=${left},top=${top},scrollbars=1`;
    // const url="#/help/manual";
    const url="/pdf/rms_menual.pdf";
    window.open(url, "popupWindow", windowOptions);
  }
  
  const menuItems = [
    {
      key: 'dashboard',
      icon: React.createElement(AppstoreOutlined),
      label: <Link to="/dashboard">대시보드</Link>,
    },
    {
      key: 'asset',
      icon: React.createElement(LaptopOutlined),
      label: <Link to="/asset">자산 관리</Link>,
    },
    // {
    //   key: 'assetaggrid',
    //   icon: React.createElement(LaptopOutlined),
    //   label: <Link to="/assetaggrid">자산 관리2</Link>,
    // },
    {
      key: 'analysis',
      icon: React.createElement(LineChartOutlined),
      label: <Link to="/analysis">취약점 분석</Link>,
    },
    {
      key: 'totalReport',
      icon: React.createElement(LineChartOutlined),
      label: <Link to="/totalReport">통합 보고서</Link>,
    },
    {
      key: 'reports',
      icon: React.createElement(ProfileOutlined),
      label: <Link to="/reports">보고서</Link>,
    },
    // {
    //   key: 'compareReport',
    //   icon: React.createElement(LineChartOutlined),
    //   label: <Link to="/compareReport">이력관리 보고서</Link>,
    // },
    {
      key: 'template',
      icon: React.createElement(BlockOutlined),
      label: <Link to="/template">템플릿 관리</Link>,
    },
    {
      key: 'log',
      icon: React.createElement(ProfileOutlined),
      label: <Link to="/log">로그 관리</Link>,
    },
    {
      key: 'config',
      icon: React.createElement(SettingOutlined),
      label: <Link to="/config">환경 설정</Link>,
    },
    // {
    //   icon: React.createElement(QuestionCircleOutlined),
    //   label: <a href="/pdf/rms_menual.pdf">메뉴얼</a>,
    // },
    {
      icon: React.createElement(QuestionCircleOutlined),
      label: <Link to="#" onClick={menualPopup}>메뉴얼</Link>,
    },
  ];

  return (
      <div className="menu">
        <Menu theme="dark" 
          mode="horizontal" 
          defaultSelectedKeys={'dashboard'} 
          items={menuItems} 
          style={{ paddng: '20px 0  px' }}
          selectedKeys={selectKey} />
      </div>
  );
};
  
export default TopMenu;